/**
 * Tonurile semantice ale noului stil de interfata (12.10.2026) — aceleasi pe toate piesele:
 * rosu = problema, galben = de verificat, albastru = de facut / informativ, verde = gata,
 * mov = nou, gri = inchis / neutru. Clasele sunt scrise intregi, ca Tailwind sa le gaseasca.
 */
export type Ton = 'rosu' | 'galben' | 'albastru' | 'verde' | 'mov' | 'gri'

export const TON: Record<
  Ton,
  { bara: string; fundal: string; text: string; contur: string; pastila: string }
> = {
  rosu: {
    bara: 'border-l-b4l-red',
    fundal: 'bg-b4l-red-light',
    text: 'text-b4l-red-dark',
    contur: 'border-b4l-red ring-b4l-red',
    pastila: 'bg-b4l-red-light text-b4l-red-dark',
  },
  galben: {
    bara: 'border-l-b4l-amber',
    fundal: 'bg-b4l-amber-light',
    text: 'text-b4l-amber-dark',
    contur: 'border-b4l-amber ring-b4l-amber',
    pastila: 'bg-b4l-amber-light text-b4l-amber-dark',
  },
  albastru: {
    bara: 'border-l-b4l-blue',
    fundal: 'bg-b4l-blue-light',
    text: 'text-b4l-blue-dark',
    contur: 'border-b4l-blue ring-b4l-blue',
    pastila: 'bg-b4l-blue-light text-b4l-blue-dark',
  },
  verde: {
    bara: 'border-l-b4l-green',
    fundal: 'bg-b4l-green-light',
    text: 'text-b4l-green-dark',
    contur: 'border-b4l-green ring-b4l-green',
    pastila: 'bg-b4l-green-light text-b4l-green-dark',
  },
  mov: {
    bara: 'border-l-b4l-purple',
    fundal: 'bg-b4l-purple-light',
    text: 'text-b4l-purple-dark',
    contur: 'border-b4l-purple ring-b4l-purple',
    pastila: 'bg-b4l-purple-light text-b4l-purple-dark',
  },
  gri: {
    bara: 'border-l-b4l-text-dim',
    fundal: 'bg-b4l-bg',
    text: 'text-b4l-text-muted',
    contur: 'border-b4l-text-dim ring-b4l-text-dim',
    pastila: 'bg-b4l-bg text-b4l-text-muted border border-b4l-border',
  },
}
